import AziendaNavContainer from "../features/azienda/AziendaNavContainer";
import Pagination from "../components/dataTable/Pagination";
import React, {useEffect} from "react";
import {useQueryFilter} from "@components/dataTable/customHooks";
import {usePagination} from "@components/dataTable/usePagination";
import {AziendaBase} from "@commons/mapping/AziendaNavRecord";
import {useGetUnitaLocaliQuery} from "@commons/features/unitaLocali/api";
import {useGetAziendaQuery} from "@commons/features/azienda/api";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {changeAzienda, selectIdAziendaMaster} from "@commons/core.slice";
import DTTable from "../components/dataTable/Table";
import DTTitle from "../components/dataTable/TableTitle";
import {ULParams} from "@commons/utils/APIParams";
import * as Buttons from "../components/dataTable/buttons";

export default function Azienda() {
    const dispatch = useAppDispatch();
    const pagination = usePagination('', 1, 25);
    const {page, setPage, pageLength, setPageLength, search, setSearch} = pagination;
    const {filter, setFilter, skip} = useQueryFilter<ULParams>({idAzienda: null, codAzienda: null} as ULParams, pagination);

    const {data} = useGetUnitaLocaliQuery(filter, {skip: skip || !filter.codAzienda});

    const idAziendaMaster = useAppSelector(selectIdAziendaMaster);
    const aziendaQuery = useGetAziendaQuery({idAzienda: idAziendaMaster!}, {skip: !idAziendaMaster});

    useEffect(() => {
        if (idAziendaMaster && aziendaQuery.data) {
            setFilter(filter => ({
                ...filter,
                idAzienda: idAziendaMaster,
                codAzienda: aziendaQuery.data ? aziendaQuery.data.codAzienda : null
            }));
        }
    }, [idAziendaMaster, aziendaQuery.data, setFilter])

    function modifica(idAzienda: number) {
        dispatch(changeAzienda({idAzienda, idAziendaMaster: idAziendaMaster!, URI: null}));
    }

    return (
        <AziendaNavContainer>

            <DTTitle id="elencoUL" title="Unit&agrave; locali" {...{currentPageLength: pageLength, setPageLength, currentSearch: search, setSearch: undefined}}/>

            <DTTable<AziendaBase> dtSchema={data}
                                  header={<>
                                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                          Codice UL
                                      </th>
                                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                          Descrizione UL
                                      </th>
                                      <th scope="col" className="w-14"/>
                                  </>}

                                  rows={({item, index, isMobile, currentRow, register}) => (
                                      <tr {...register(item.idAzienda, index)}>
                                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                              {item.codFiliale}
                                          </td>

                                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                              {item.unitaLocale}
                                          </td>

                                          <td className="text-sm font-medium">
                                              <Buttons.Visibility visible={isMobile || index === currentRow}>
                                                  <Buttons.GO onAction={() => modifica(item.idAzienda)}/>
                                              </Buttons.Visibility>
                                          </td>
                                      </tr>)
                                  }
            />

            <Pagination dataTables={data} currentPage={page} setPage={setPage} currentPageLength={pageLength}></Pagination>

        </AziendaNavContainer>
    )
}
